// extracted by mini-css-extract-plugin
export default {"sparkline":"CoinSparkline_sparkline__JODX7"};